<template>
  <div class="card" :key="vehicle.id" v-for="vehicle in vehicles" style="margin-bottom: 20px">
    <h5 :class="vehicle.active ? 'card-header bg-primary text-white' : 'card-header bg-secondary text-white'">
      {{ vehicle.displayName || 'No Display Name' }} [{{vehicle.id}}]
    </h5>
    <div class="card-body">
      <h5 class="card-title">{{ vehicle.make }} {{ vehicle.model }} {{ vehicle.year }}</h5>
      <div class="row" style="margin-top: 20px; margin-bottom: 20px; line-height: 30px">
        <div class="col-md-4">
          Created At: {{ vehicle.createdAt }} <br />
          Status: {{ vehicle.active === true ? 'Active' : 'Inactive' }} <br />
          Registration Number: {{ vehicle.registrationNumber }} <br />
        </div>
        <div class="col-md-4">
          Color: {{ vehicle.colour }} <br />
          Fuel Type: {{ vehicle.fuelType }} <br />
          Transmission: {{ vehicle.transmission }} <br />
        </div>
        <div class="col-md-4">
          Device Serial Number: {{ vehicle.adapterSerialNumber }} <br />
          Odometer: {{ vehicle.calculatedOdometer }} <br />
          Odometer Calculated At: {{ vehicle.calculatedOdometerEndDate }} <br />
        </div>
      </div>

      <div v-if="vehicle.subscriptions && vehicle.subscriptions.length > 0">
        <h5>Subscriptions</h5>
        <table class="table table-hover">
          <thead>
            <th>Id</th>
            <th>Name</th>
            <th>Start</th>
            <th>End</th>
            <th>Provider</th>
            <th>Provider ID</th>
            <th>Status</th>
            <th>Move</th>
          </thead>
          <tbody>
            <tr :key="subscription.id" v-for="subscription in vehicle.subscriptions">
              <td>{{ subscription.id }}</td>
              <td>{{ subscription.name }}</td>
              <td>{{ subscription.startTime }}</td>
              <td>{{ subscription.endTime }}</td>
              <td>{{ subscription.subscriptionProvider }}</td>
              <td>
                <a
                  v-if="subscription.subscriptionProvider === 'chargebee-iap'"
                  :href="`https://gofar.chargebee.com/d/subscriptions/${subscription.subscriptionProviderId}`"
                  target="_blank"
                  >{{ subscription.subscriptionProviderId }}</a
                >
              </td>
              <td>{{ subscription.status }}</td>
              <td>
                <button
                  type="button"
                  class="btn btn-outline-secondary"
                  data-bs-toggle="tooltip"
                  data-bs-placement="top"
                  title="Move Subscription"
                  v-on:click="loadMoveSubscriptionModal(vehicle.id, subscription.id)"
                >
                  <i class="bi bi-box-arrow-right"></i>
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <h4 v-else>No Subscriptions!</h4>
    </div>
    <div class="card-footer d-flex flex-row-reverse">
      <button
        class="btn btn-primary"
        data-bs-toggle="tooltip"
        data-bs-placement="top"
        title="Trip Export"
        v-on:click="loadTripExportModal(vehicle.id)"
      >
        Trip Export <i class="bi bi-file-ruled"></i></button
      >&nbsp;
      <a class="btn btn-primary" :href="`/admin/vehicle/${vehicle.id}/refills`" target="_blank"
        >Refills <i class="bi bi-fuel-pump"></i></a
      >&nbsp;
      <a class="btn btn-primary" :href="`/admin/vehicle/${vehicle.id}/odometerlogs`" target="_blank"
        >Odometer Logs <i class="bi bi-speedometer"></i></a
      >&nbsp;
      <a class="btn btn-primary" :href="`/admin/vehicle/${vehicle.id}/trips`" target="_blank"
        >Trips &amp; Tags <i class="bi bi-car-front-fill"></i
      ></a>
    </div>
  </div>
  <div
    class="modal fade"
    id="tripExportModal"
    tabindex="-1"
    role="dialog"
    aria-labelledby="tripExportModalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-xl" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="tripExportModalLabel">Trip Export</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <form>
            <div class="row mb-3">
              <div class="row col-md-6">
                <label for="startTime" class="col-md-3 col-form-label">Start Time</label>
                <div class="col-md-9">
                  <input type="date" class="form-control" id="startTime" v-model="tripExportBody.startTime" />
                </div>
              </div>
              <div class="row col-md-6">
                <label for="endTime" class="col-sm-3 col-form-label">End Time</label>
                <div class="col-sm-9">
                  <input type="date" class="form-control" id="endTime" v-model="tripExportBody.endTime" />
                </div>
              </div>
            </div>
            <div class="row mb-3">
              <div class="row col-md-6">
                <label for="exportOption" class="col-sm-3 col-form-label">Export Option</label>
                <div class="col-sm-9">
                  <div class="btn-group" role="group" aria-label="Basic radio toggle button group">
                    <input
                      type="radio"
                      class="btn-check"
                      name="exportOption"
                      id="btnradio1"
                      autocomplete="off"
                      checked
                      v-on:click="setExportOption('simple')"
                    />
                    <label class="btn btn-outline-primary" for="btnradio1">Simple</label>

                    <input
                      type="radio"
                      class="btn-check"
                      name="exportOption"
                      id="btnradio2"
                      autocomplete="off"
                      v-on:click="setExportOption('business')"
                    />
                    <label class="btn btn-outline-primary" for="btnradio2">Business</label>

                    <input
                      type="radio"
                      class="btn-check"
                      name="exportOption"
                      id="btnradio3"
                      autocomplete="off"
                      v-on:click="setExportOption('ato')"
                    />
                    <label class="btn btn-outline-primary" for="btnradio3">ATO</label>
                  </div>
                </div>
              </div>
              <div class="row col-md-6">
                <label for="includePDF" class="col-md-4 col-form-label">Include PDF Report</label>
                <div class="col-md-1">
                  <input
                    class="form-check-input"
                    type="checkbox"
                    value=""
                    id="includePDF"
                    v-model="tripExportBody.shouldIncludePDF"
                  />
                </div>
              </div>
            </div>
            <div class="row mb-3">
              <div class="row col-md-6">
                <label for="timezone" class="col-sm-3 col-form-label">Timezone</label>
                <div class="col-sm-9">
                  <input type="text" class="form-control" id="timezone" v-model="tripExportBody.timezone" />
                </div>
              </div>
              <div class="row col-md-6">
                <label for="sentTo" class="col-sm-3 col-form-label">Sent To</label>
                <div class="col-sm-9">
                  <input type="text" class="form-control" id="sentTo" v-model="tripExportBody.email" />
                </div>
              </div>
            </div>
          </form>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-primary" v-on:click="tripExport()">Export</button>
        </div>
      </div>
    </div>
  </div>

  <div
    class="modal fade"
    id="moveSubscriptionModal"
    tabindex="-1"
    role="dialog"
    aria-labelledby="moveSubscriptionModal"
    aria-hidden="true"
  >
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="moveSubscriptionModalLabel">Move Subscription</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <form>
            <div class="vehicle mb-3">
              <label for="inputEmail3" class="col-sm-3 col-form-label">Vehicle</label>
              <div class="col-sm-9">
                <select
                  class="form-control"
                  id="selectedVehicleToMoveSubscription"
                  v-model="subscriptionMigration.newVehicleId"
                >
                  <option
                    :value="vehicleOption.id"
                    v-for="vehicleOption in subscriptionMigration.vehicleOptions"
                    :key="vehicleOption.id"
                  >
                    {{ vehicleOption.make }}-{{ vehicleOption.model }}-{{ vehicleOption.year }}
                  </option>
                </select>
              </div>
            </div>
          </form>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-primary"
            v-on:click="
              moveSubscription(
                subscriptionMigration.oldVehicleId,
                subscriptionMigration.newVehicleId,
                subscriptionMigration.subscriptionId
              )
            "
          >
            Move Subscription
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { apiClient } from '../../helpers/api-client';
import { HTTP_METHODS, HTTP_STATUS_CODES } from '../../helpers/config';

let tripExportModal;
let moveSubscriptionModal;

export default {
  name: 'VehiclesView',
  setup() {},
  data() {
    return {
      userId: '',
      vehicleId: '',
      user: {},
      vehicles: [],
      subscriptionMigration: {
        vehicleOptions: [],
        oldVehicleId: '',
        newVehicleId: '',
        subscriptionId: ''
      },
      tripExportBody: {
        startTime: '',
        endTime: '',
        exportOption: 'simple',
        email: 'al@gofar.co',
        timezone: 'Australia/Sydney',
        shouldIncludePdf: 'false'
      }
    };
  },
  async created() {
    this.userId = this.$route.params.id;
    await this.loadUser(this.$route.params.id);
    await this.loadVehicles(this.$route.params.id);
  },
  mounted() {
    tripExportModal = new bootstrap.Modal(document.getElementById('tripExportModal'), {
      keyboard: false
    });
    moveSubscriptionModal = new bootstrap.Modal(document.getElementById('moveSubscriptionModal'), {
      keyboard: false
    });
  },
  computed: {
    formattedFilter() {
      const result = {
        filter: {
          where: {
            and: [
              {
                startTime: {
                  gt: this.tripExportBody.startTime.toString('YYYY-MM-DD')
                }
              },
              {
                startTime: {
                  lt: this.tripExportBody.endTime.toString('YYYY-MM-DD')
                }
              }
            ]
          },
          exportOption: this.tripExportBody.exportOption,
          format: 'csv',
          pdf: this.tripExportBody.shouldIncludePdf ? 'true' : 'false',
          email: this.tripExportBody.email,
          timezone: this.tripExportBody.timezone
        }
      };
      return result;
    }
  },
  methods: {
    setExportOption(exportOption) {
      this.tripExportBody.exportOption = exportOption;
    },
    loadTripExportModal(vehicleId) {
      this.vehicleId = vehicleId;
      tripExportModal.show();
    },
    loadMoveSubscriptionModal(vehicleId, subscriptionId) {
      this.subscriptionMigration.vehicleOptions = this.vehicles.filter((vehicle) => vehicle.id !== vehicleId);
      this.subscriptionMigration.oldVehicleId = vehicleId;
      this.subscriptionMigration.subscriptionId = subscriptionId;
      moveSubscriptionModal.show();
    },
    loadUser: async function (userId) {
      const result = await apiClient(`users/${userId}`, HTTP_METHODS.GET);
      if (result.status === HTTP_STATUS_CODES.SUCCESS) {
        this.user = result.data;
      }
    },
    loadVehicles: async function (userId) {
      const result = await apiClient(`users/${userId}/ownedVehicles`, HTTP_METHODS.GET);
      if (result.status === HTTP_STATUS_CODES.SUCCESS) {
        const activeVehicles = result.data.filter((vehicle)=> vehicle.active);
        const inactiveVehicles = result.data.filter((vehicle)=> !vehicle.active);
        // to show the active vehicles on top
        this.vehicles = [...activeVehicles, ...inactiveVehicles];
      }
      const subscriptionResult = await apiClient(`users/${userId}/user-enabled-features`, HTTP_METHODS.GET);
      if (subscriptionResult.status === HTTP_STATUS_CODES.SUCCESS) {
        this.vehicles.forEach((vehicle) => {
          vehicle.subscriptions = subscriptionResult.data.vehicles[vehicle.id].map((subscription) => {
            return {
              id: subscription.metadata.id,
              name: subscription.metadata.SubscriptionTypeId,
              startTime: subscription.metadata.startTime,
              endTime: subscription.metadata.endTime,
              subscriptionProvider: subscription.metadata.metadata.subscriptionProvider,
              subscriptionProviderId: subscription.metadata.metadata.chargebeeSubscriptionId,
              status: subscription.metadata.status
            };
          });
        });
      }
    },
    tripExport: async function () {
      const filter = encodeURI(JSON.stringify(this.formattedFilter));
      const tripExportUrl = `users/${this.userId}/vehicle/${this.vehicleId}/trips?filter=${filter}`;
      const result = await apiClient(tripExportUrl, HTTP_METHODS.GET);
      if (result.status === HTTP_STATUS_CODES.SUCCESS) {
        alert(result.data.result);
      }
    },
    moveSubscription: async function (oldVehicleId, newVehicleId, subscriptionId) {
      if (oldVehicleId && newVehicleId && subscriptionId) {
        const moveSubscriptionResult = await apiClient(`vehicles/move-subscription`, HTTP_METHODS.POST, {
          newVehicleId,
          subscriptionId
        });
        if (moveSubscriptionResult.status === HTTP_STATUS_CODES.NO_CONTENT) {
          moveSubscriptionModal.hide();
          await this.loadVehicles(this.userId);
        }
      }
    }
  }
};
</script>
